import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Tab } from '@mui/material'
import React from 'react'
import AdminLayout from '../../components/admin/AdminLayout'
import { useTranslation } from 'react-i18next';
import QuestionsCategoriesByAdmin from '../../components/admin/QuestionsCategoriesByAdmin';
import QuestionsCategoriesPendingByAdmin from '../../components/admin/QuestionsCategoriesPendingByAdmin';

export default function AdminQuestions() {
    const {t} = useTranslation()
    const [value, setValue] = React.useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <AdminLayout>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label={t('Questions')} value="1" />
                        <Tab label={t('pending questions')} value="2" />
                    </TabList>
                </Box>
                    <TabPanel value="1"><QuestionsCategoriesByAdmin/></TabPanel>
                    <TabPanel value="2"><QuestionsCategoriesPendingByAdmin/></TabPanel>
                </TabContext>
        </AdminLayout>
    )
}